export const SIGN_UP = {
  SET_ADDRESSES: 'SET_ADDRESSES',
  SET_CREDENTIALS: 'SET_CREDENTIALS',
  SET_INFO: 'SET_INFO',
  SET_INVITE_INFO: 'SET_INVITE_INFO',
};

export const setInviteInfo = payload => ({
  type: SIGN_UP.SET_INVITE_INFO,
  payload,
});

export const setCredentials = payload => ({
  type: SIGN_UP.SET_CREDENTIALS,
  payload,
});

export const setAddresses = payload => ({
  type: SIGN_UP.SET_ADDRESSES,
  payload,
});

export const setInfo = payload => ({
  type: SIGN_UP.SET_INFO,
  payload,
});
